module.exports = __webpack_public_path__ + "img/icon-title-1.2752e7b2.png";